import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import analytics from "../services/analytics";
import Spinner from "../components/common/Spinner";
import AuthCard from "./AuthCard";
import { colors, typography, buttons, form } from "../styles/index";

const API_BASE = process.env.REACT_APP_API_URL;
const MIN_PASSWORD = 8;

// Signing up starts a new organization with you as its owner; colleagues join by invitation (Settings → Members).
export default function RegisterPage() {
  const [orgName, setOrgName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError("");
    if (!orgName.trim()) return setError("Enter your organization's name.");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return setError("Please enter a valid work email address.");
    if (password.length < MIN_PASSWORD) return setError(`Use at least ${MIN_PASSWORD} characters for the password.`);
    if (password !== confirm) return setError("Passwords do not match.");
    setLoading(true);
    try {
      await axios.post(`${API_BASE}/request-register`, new URLSearchParams({ username: email, password, org_name: orgName.trim() }));
      analytics.trackSignup("email");
      navigate("/login", { state: { message: "Almost there - check your email and click the link to confirm your account." } });
    } catch (err) {
      setError(err.response?.data?.detail || "Sign-up failed. Please try again.");
    } finally {
      setLoading(false);
    }
    return undefined;
  };

  const field = (id, label, props) => (
    <div style={{ marginBottom: 16 }}>
      <label style={form.label} htmlFor={id}>{label}</label>
      <input id={id} style={form.input} disabled={loading} {...props} />
    </div>
  );

  return (
    <AuthCard subtitle="Create your team's studio">
      <form onSubmit={handleSubmit}>
        {field("org", "Organization", { value: orgName, onChange: (e) => setOrgName(e.target.value), placeholder: "Acme Logistics", maxLength: 120 })}
        {field("email", "Work email", { type: "email", autoComplete: "email", value: email, onChange: (e) => setEmail(e.target.value), placeholder: "you@company.com" })}
        {field("password", "Password", { type: "password", autoComplete: "new-password", value: password, onChange: (e) => setPassword(e.target.value) })}
        {field("confirm", "Confirm password", { type: "password", autoComplete: "new-password", value: confirm, onChange: (e) => setConfirm(e.target.value) })}
        {error && <div style={{ ...form.error, marginBottom: 12 }} role="alert">{error}</div>}
        <button type="submit" disabled={loading} style={{ ...buttons.primary, width: "100%", opacity: loading ? 0.7 : 1 }}>
          {loading ? <><Spinner size={14} /> Sending...</> : "Create account"}
        </button>
        <p style={{ ...typography.small, marginTop: 20, textAlign: "center", color: colors.textMuted }}>
          Joining a colleague&rsquo;s team? Use the invitation link they sent you. Already have an account? <Link to="/login">Sign in</Link>.
        </p>
      </form>
    </AuthCard>
  );
}
